import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { SELECT_CONTRACT_RATE_TYPE } from "../../../api-setup/api-endpoints";

export const fetchContractRateType = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: "",
    };

    const response = await POSTAPI(false, SELECT_CONTRACT_RATE_TYPE, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      const transformedData = rawData.map((rateType) => ({
        id: rateType.rate_type_mstr_key,
        text: rateType.display_name,
        value: rateType.value,
        description: rateType.description,
        sortOrder: rateType.sort_order,
      }));

      return {
        success: true,
        rateTypeData: transformedData,
        rawData: rawData,
      };
    } else {
      console.error("Failed to fetch rate type data:", response?.message || "Invalid response structure");
      return {
        success: false,
        rateTypeData: [],
        rawData: [],
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching rate type data:", error);
    return {
      success: false,
      rateTypeData: [],
      rawData: [],
      error: error.message,
    };
  }
};
